module.exports = __webpack_public_path__ + "Flag-380.e0f065dbae5efe84409b69db69282311.svg";